var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMale = function SvgMale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3010_39212)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FFDF9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9727 32.8533V38.08H22.026C22.026 38.08 22.0484 30.352 22.026 25.2351C19.3507 21.7674 19.3507 19.6 21.466 17.36C23.5813 15.12 38.6393 14 38.6393 14C38.6393 14 39.769 24.8659 39.946 27.8133C40.0171 28.9987 40.786 32.8533 37.7993 32.8533H33.9727Z",
    fill: "url(#paint0_linear_3010_39212)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9731 32.48C31.5416 32.2148 29.1907 31.4524 27.0664 30.24C27.0664 30.24 28.3731 33.7867 33.9731 34.9067V32.48Z",
    fill: "#F08956"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4568 19.6386C23.8632 19.1288 23.1419 18.7855 22.1224 19.3153C19.7052 20.5702 21.3094 25.412 24.0144 25.3175C24.9477 25.285 24.5199 27.145 22.0264 28.3734C22.0264 26.4134 19.0397 21.5601 18.7784 17.1413C15.7731 16.0223 16.5197 11.5447 18.583 11.5447C18.2537 7.43971 24.8264 5.31955 27.3714 7.6751C29.9597 4.57289 36.4931 6.15955 36.8875 8.85091C41.38 6.45281 44.3331 13.3462 40.1265 16.0223C38.3956 17.1236 34.3464 17.5427 28.5013 17.5427C25.6965 17.5427 27.3095 24.1077 28.1864 26.2268C29.3064 28.9334 35.5597 29.3068 37.5198 29.0268C39.0504 28.8082 39.8531 28.1868 39.9464 27.8134C41.3464 31.5468 39.5731 33.7868 36.7731 33.7868C32.0131 33.7868 27.2531 32.3868 26.5064 28.9334C25.9121 26.1852 25.9447 21.7498 24.4568 19.6386Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5996 45.4175C48.7843 47.8264 49.7177 51.8086 50.3996 57.3642H5.59961C6.28181 51.808 7.21515 47.8258 8.39961 45.4175C9.58009 43.017 20.5329 38.3972 20.5329 38.3972C20.5329 38.3972 20.751 36.2854 21.2796 35.9826C21.8082 35.6799 34.09 35.68 34.7196 35.9826C35.3492 36.2852 35.4663 38.396 35.4663 38.396C35.4663 38.396 46.4214 43.022 47.5996 45.4175Z",
    fill: "#D6AE56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3010_39212",
    x1: 30.0148,
    y1: 14,
    x2: 30.0148,
    y2: 38.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC299"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3010_39212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  })))));
};
export default SvgMale;